<template>
  <uploader
    :options="options"
    :class="['xian-big-upload', 'uploader-example sr-big-upload']"
    ref="uploader"
    @file-success="fileSuccess"
    @file-added="onFileAdded"
    @file-progress="onFileProgress"
    @file-error="onFileError"
    @file-removed="onFileRemove"
    style="width: 100%"
  >
    <!-- 上传按钮的html -->
    <div
      :class="[
        item.disabled ? 'uploaderDisabled upload-tip' : 'upload-tip',
        'xian_upload_tip',
      ]"
    >
      <uploader-btn :single="true">
        <!-- <el-button icon="el-icon-upload2">点击上传</el-button> -->
          <div class="btn">
            <i class="el-icon-upload2"></i>点击上传
          </div>
      </uploader-btn>
      <slot name="templateDownload"></slot>
    </div>
    <div class="uploadDiv xian" v-if="(list && list.length) || fileListLength">
      <div
        class="uploader-file-info xian_uploader_file_item success"
        v-for="(fitem, index) in list"
        :key="'fitem_' + index"
      >
        <div class="file-name">
          <i class="el-icon-paperclip"></i>
          <span class="name" :title="fitem.name || fitem.fileName">{{
            fitem.name || fitem.fileName
          }}</span>
        </div>
        <div class="operate">
          <div class="time">
            {{ fitem.createTime }}
          </div>
          <el-popover placement="top" width="54" trigger="hover" content="查看">
            <div class="btn" slot="reference">
              <i @click="toDwon(fitem)" class="el-icon-view"></i>
            </div>
          </el-popover>

          <el-popover placement="top" width="54" trigger="hover" content="删除">
            <div class="btn" slot="reference">
              <i @click="remove(fitem)" class="el-icon-close"></i>
            </div>
          </el-popover>
        </div>
      </div>
      <!-- 正在上传的附件列表 -->
      <uploader-list>
        <template slot-scope="scope">
          <uploader-file
            :file="itemEr"
            v-for="(itemEr, index) in scope.fileList"
            :key="'itemEr_' + index"
            :list="true"
            @pause="pause"
            @resume="resume"
            @startUpload="startUpload"
          ></uploader-file>
        </template>
      </uploader-list>
    </div>
  </uploader>
</template>

<script>
import uploaderFile from "./file.vue";
import { md5Mixin } from "./common/mixins";
export default {
  name: "SrBigUpload",
  provide() {
    return {
      uploader: this.$refs.uploader,
    };
  },
  computed: {
    origin() {
      return sessionStorage.getItem("origin") || "";
    },
  },
  props: {
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  inject: ["baseUrl", "imgBaseUrl", "uploadBaseUrl"],
  mixins: [md5Mixin],
  watch: {
    fileList(val) {
      this.list = JSON.parse(JSON.stringify(val));
      this.getUploaderWidth();
    },
    uploader: {
      handler: function (n) {
        this.fileListLength = this.uploader.fileList.length;
      },
      deep: true,
    },
  },
  data() {
    return {
      list: JSON.parse(JSON.stringify(this.fileList)),
      fileListMaxLength: 10,
      fileListLength: 0,
    };
  },
  mounted() {
    this.getUploaderWidth();
  },
  components: {
    uploaderFile,
  },
  methods: {
    toDwon(file) {
      // this.uploadRequest.download(file.fileId).then(res => {
      //   console.log(res, 111111)
      //      this.download(res, file)
      //   })
      window.open(file.url);
      // let token = sessionStorage.getItem("token");
      // if (
      //   [
      //     "txt",
      //     "ppt",
      //     "pptx",
      //     "doc",
      //     "docx",
      //     "xls",
      //     "xlsx",
      //     "html",
      //     "pdf",
      //   ].includes(file.name.split(".").pop())
      // ) {
      //   window.open(file.id);
      //   // window.open(`${this.baseUrl}/viewPdf?id=${file.id}`);
      // } else {
        
      // }
    },
    /**
     * 现在一个上传框的宽度为202px
     */
    getUploaderWidth() {
      if (
        this.item.target !== "editor" &&
        !this.item.hideMore &&
        this.$refs.uploader.$el &&
        this.$refs.uploader.$el.offsetWidth
      ) {
        this.fileListMaxLength =
          Math.floor(this.$refs.uploader.$el.offsetWidth / 202) - 1;
      }
    },
    download(res, file) {
      /** bold 类型  创建一个dom对象 标签 a */
      const a = document.createElement('a')
      /** 对bold 类型 解析地址 */
      a.href = URL.createObjectURL(res)
      /** a 标签的属性 */
      a.download = file.name || file.fileName // 这里填保存成的文件名
      /** 点击事件 */
      a.click()
      /** 销毁 */
      URL.revokeObjectURL(a.href)
    }
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrBigUpload/SrBigUpload.vue